// extracted by mini-css-extract-plugin
module.exports = {"gridWrapper":"GridPageWrapper_gridWrapper__BkN1_","title":"GridPageWrapper_title__1iVBF"};